import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase, startCase } from 'lodash';

export default function WaitlistStatusCell({ lead }) {
  const approvalStatus = lead.approvalStatus;
  if (!approvalStatus) return <span>--</span>;

  const label = startCase(approvalStatus);
  const labelClasses = [`label-waitlist-${kebabCase(approvalStatus)}`];
  labelClasses.push(`ds-label-waitlist-${kebabCase(approvalStatus)}`);

  return (
    <span className={`label pill-label ${labelClasses.join(' ')}`}>
      {label}
    </span>
  );
}

WaitlistStatusCell.propTypes = {
  lead: PropTypes.shape({
    approvalStatus: PropTypes.string
  }).isRequired
};
